<template>
  <rc-but-list v-bind="$attrs.column.button || []" @confirm="confirmButtonType"></rc-but-list>
</template>

<script>
import { emitFun } from "@/utils";

export default {
  name: "RcButtonType",
  methods: {
    confirmButtonType(item, index, obj) {
      emitFun({ self: this, emit: true }, { item, index }, { ...obj, attrs: this.$attrs, row: this.$attrs.row, name: "rcButtonType" });
    },
    delete(item, index, obj) {
      const { refs, row } = this.$attrs;
      const table = refs && refs.table;
      const tableSelf = table && table.$parent;
      tableSelf.selectionChange([row]);
      tableSelf.delete(item, index, obj);
    }
  }
};
</script>

<style>

</style>
